export default [
    {
        path: '/hris',
        meta: {
            title: "Human Resource",
            icon: "menu-logo.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/Index'),
        redirect: { name: 'hris.dashboard' },
        children: [
            {
                path: 'dashboard',
                name: 'hris.dashboard',
                meta: {
                    title: "HRIS Dashboard",
                    show: true
                },
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/HrisDashboard'),
            },
            {
                path: 'leavepermit',
                name: 'hris.validation',
                meta: {
                    title: "Leave Permit Validation",
                    show: true
                },
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/LeaveValidation'),
            },
            {
                path: 'leavepermit/:id',
                name: 'hris.validation.detail',
                meta: {
                    title: "Leave Permit Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/LeaveValidationApproval'),
            },
            {
                path: 'leavepermit/:id/:approval/:role',
                name: 'hris.validation.approval',
                meta: {
                    title: "Leave Permit Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/LeaveValidationApproval'),
            },
            {
                path: 'spk',
                name: 'hris.spk',
                meta: {
                    title: "SPK Validation",
                    show: true
                },
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/SPKValidation'),
            },
            {
                path: 'spk/:id',
                name: 'hris.spk.detail',
                meta: {
                    title: "SPK Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/SPKValidationApproval'),
            },
            {
                path: 'spk/:id/:approval/:role',
                name: 'hris.spk.approval',
                meta: {
                    title: "SPK Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/SPKValidationApproval'),
            },
            {
                path: 'overtime',
                name: 'hris.overtime',
                meta: {
                    title: "Overtime Validation",
                    show: true
                },
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/OvertimeValidation'),
            },
            {
                path: 'overtime/:id',
                name: 'hris.overtime.detail',
                meta: {
                    title: "Overtime Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/OvertimeValidationApproval'),
            },
            {
                path: 'overtime/:id/:approval/:role',
                name: 'hris.overtime.approval',
                meta: {
                    title: "Overtime Validation",
                    show: true
                },
                props: true,
                component: () => import(/* webpackChunkName: "hris" */ '../views/admin/page/HrisPage/OvertimeValidationApproval'),
            },
        ]
    }
]